// extracted by mini-css-extract-plugin
export var bgimageContainer = "categoryPage-module--bgimageContainer--npb94";
export var box = "categoryPage-module--box--oVp1G";
export var header = "categoryPage-module--header--1pQkY";
export var itemsContainer = "categoryPage-module--itemsContainer--ImfOI";
export var markdownContainer = "categoryPage-module--markdownContainer--MJyO3";
export var titleContainer = "categoryPage-module--titleContainer--4NnZ1";